import { Action } from 'redux';
import { ImageSettingsActionListEnum } from './actionsTypes';
import { ImageSettingsTypes } from '../imageSettingsTypes';

interface ImageSettingsChangeImageTypeActionType extends Action {
  type: ImageSettingsActionListEnum.CHANGE_IMAGE_TYPE;
  imageType: string;
}

interface ResetImageSettingsActionType extends Action {
  type: ImageSettingsActionListEnum.RESET_IMAGE_SETTINGS;
  imageSettings: ImageSettingsTypes;
}

export type ImageSettingsActionType = ImageSettingsChangeImageTypeActionType | ResetImageSettingsActionType;

export const imageSettingsChangeImageTypeAction = (imageType: string): ImageSettingsChangeImageTypeActionType => ({
  type: ImageSettingsActionListEnum.CHANGE_IMAGE_TYPE,
  imageType,
});

export const resetImageSettingsAction = (imageSettings: ImageSettingsTypes): ResetImageSettingsActionType => ({
  type: ImageSettingsActionListEnum.RESET_IMAGE_SETTINGS,
  imageSettings,
});
